/**
 * Created by jiachenpan on 16/11/18.
 */

// export function isvalidEmail(email) {
//   var reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
//   return reg.test(email)
// }

export function isvalidUsername(str) {
  return str.replace(/^\s+|\s+$/g,'').length >= 0
}

/* 合法uri*/
export function validateURL(textval) {
  const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return urlregex.test(textval)
}

/* 小写字母*/
export function validateLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/* 大写字母*/
export function validateUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/* 大小写字母*/
export function validatAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

export function isExternal(path) {
    return /^(https?:|mailto:|tel:)/.test(path)
}

/* 大小写字母,数字,下划线*/
export function validatAlphabetsUnderline(str) {
  const reg = /^[\u4e00-\u9fa5A-Za-z0-9_]+$/
  return reg.test(str)
}

//文件格式 magic number
const magicNumberMap = {
  // 圖片格式
  'FFD8FFE0': 'image/jpeg',
  'FFD8FFE1': 'image/jpeg',
  'FFD8FFDB': 'image/jpg',
  '89504E47': 'image/png',
  '47494638': 'image/gif',
  '52494646': 'image/webp',

  // 影片格式
  '00000018': 'video/mp4', // MP4
  '00000020': 'video/mp4', // MP4
  '66747970': 'video/mp4', // MP4 (ftyp)
  '0000001C': 'video/quicktime', // MOV
  '6D6F6F76': 'video/quicktime', // MOV
  '1A45DFA3': 'video/x-matroska', // MKV
  '52494646': 'video/x-msvideo', // AVI
  '464C5601': 'video/x-flv', // FLV
  '3026B275': 'video/x-ms-wmv', // WMV
  '00000014': 'video/3gpp', // 3GP
  '000001BA': 'video/mpeg' // MPEG
};

//驗證文件格式 MIME type & magic number
export function validateUploadFileMagicNumber(file, type = 'image', excludedMimeTypes = []) {
  console.log('file', file)
  return new Promise((resolve, reject) => {
    switch (type) {
      case 'image':
        if (!file.type.includes('image/')) {
          reject({ status: false, message: '上传失败，仅支持图片' });
        }
        if(excludedMimeTypes.length > 0 && excludedMimeTypes.includes(file.type)) {
          reject({ status: false, message: `上传失败，不支持 ${file.type} 格式` });
        }
        break;
      case 'video':
        if (!file.type.includes('video/')) {
          reject({ status: false, message: '上传失败，仅支持视频' });
        }
        if(excludedMimeTypes.length > 0 && excludedMimeTypes.includes(file.type)) {
          reject({ status: false, message: `上传失败，不支持 ${file.type} 格式` });
        }
        break;
      default:
        break;
      }

    const reader = new FileReader();
    // 當文件被成功讀取時執行
    reader.onload = (e) => {
      const buffer = new Uint8Array(e.target.result); // 獲取文件的二進制數據
      const hex = Array.from(buffer)
        .slice(0, 4) // 取前4個字節
        .map((b) => b.toString(16).padStart(2, '0').toUpperCase()) // 轉換為十六進制
        .join('');
      console.info('hex', hex);

      // 驗證 Magic Number 是否匹配
      const mimeType = magicNumberMap[hex] || 'unknown';
      console.info('mimeType', mimeType);

      if (mimeType === 'unknown') {
        reject({ status: false, message: '上传失败，文件格式不支持' });
        return;
      }

      // 如果傳入了排除的 MIME 類型清單，檢查是否需要排除
      if (excludedMimeTypes.length > 0 && excludedMimeTypes.includes(mimeType)) {
        reject({ status: false, message: `上传失败，不支持 ${mimeType} 格式` });
        return;
      }

      // 文件驗證通過
      resolve({ status: true, mimeType });

    };

    // 當讀取出錯時執行
    reader.onerror = () => {
      reject({ status: false, message: '无法读取文件' });
    };

    // 讀取文件的前4個字節
    reader.readAsArrayBuffer(file.slice(0, 4));
  });
}